<template>
  <el-container>
    <el-header>
      <el-select v-model="project_id" filterable placeholder="请选择项目" @change="projectChange()">
        <el-option
          v-for="item in project_list"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary" @click="addTabelRow()">新增行</el-button>
      <el-button type="primary">生成流程审核表单</el-button>
    </el-header>

    <el-main>
      <template>
       <el-table
         :data="tableData"
         style="width: 100%"
         max-height="700">

         <el-table-column
           prop="number"
           label="仪表编号"
           width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.number"></el-input>
          </template>
         </el-table-column>

         <el-table-column
           prop="house_name"
           label="所在房产">
         </el-table-column>

         <el-table-column
           prop="meter_type"
           label="仪表类型">
           <template slot-scope="scope">
            <el-select size="mini" style="width: 100%" v-model="scope.row.meter_type" placeholder="类型">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
           </template>
         </el-table-column>

         <el-table-column
           prop="charge_type"
           label="收费标准">
           <template slot-scope="scope">
            <el-select size="mini" style="width: 100%" v-model="scope.row.charge_type" filterable placeholder="收费标准">
              <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
           </template>
         </el-table-column>

         <el-table-column
           prop="status"
           label="仪表状态">
           <template slot-scope="scope">
            <el-select size="mini" style="width: 100%" v-model="scope.row.status" placeholder="仪表状态">
              <el-option key="1" label="在用" value="1"></el-option>
              <el-option key="2" label="停用" value="2"></el-option>
            </el-select>
           </template>
         </el-table-column>

         <el-table-column
           prop="energy_nature"
           label="能耗性质">
           <template slot-scope="scope">
            <el-select size="mini" style="width: 100%" v-model="scope.row.energy_nature" placeholder="能耗性质">
              <el-option key="1" label="住宅耗能" value="1"></el-option>
              <el-option key="2" label="商铺耗能" value="2"></el-option>
            </el-select>
           </template>
         </el-table-column>

         <el-table-column
           prop="upid"
           label="上级仪表">
           <template slot-scope="scope">
            <el-select size="mini" style="width: 100%" v-model="scope.row.upid" placeholder="上级仪表">
              <el-option v-for="item in meter_list" :key="item.id" :label="item.number" :value="item.id"></el-option>
            </el-select>
           </template>
         </el-table-column>

         <el-table-column
           fixed="right"
           label="操作"
           width="120">
           <template slot-scope="scope">
             <el-button
               @click.native.prevent="deleteRow(scope.$index, tableData)"
               type="text"
               size="small">
               移除
             </el-button>
           </template>
         </el-table-column>

       </el-table>
      </template>
    </el-main>
  </el-container>

</template>

<script>
import UploadFileSysc from "./components/UploadFileSysc";
import CommonHelp from "../Contract/common/CommonHelp";
export default {
  name: "MeterExcel",
  components: {UploadFileSysc},
  data () {
    return {
      tableData:[{
          'number':'',
          'meter_type':'',
          'charge_type':'',
          'status':'',
          'energys':'',
          'energy_nature':'',
          'upid':'',
        }],
      project_id:'',
      project_list:[],
      meter_type_list:[],
      house_charge_list:[],
      meter_list:[],

      host_url:"",
      loading: false,
    }
  },
  created() {
    this.getProjectList();
    this.getMeterTypeList();
  },
  methods: {
    addTabelRow(){
        if(this.project_id == ''){
          this.$Message.error('请先选择项目');
          return;
        }

        var row = {
          'number':'',
          'project_id':this.project_id,
          'meter_type':'',
          'charge_type':'',
          'status':'1',
          'energys':'',
          'energy_nature':'1',
          'upid':'',
        }
        this.tableData.push(row);
    },
    getMeterTypeList(){
      var that=this;
      let param={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          param:JSON.stringify(param),
          field:"id,name,expenditure_ids,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getProjectList(){
      var that = this;
      ERP.getRequest({url: "admin/common/pindex", data:{}}, res => {
        if(res.code==200) {
          that.project_list = res.data
        }
            console.log(res);
      })
    },
    projectChange(){
      this.getHouseChargeList();
      this.getMeterList();
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      where.pindex_id=this.project_id;
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 9999
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    getMeterList(){
      var that=this;
      let where={};
      where.project_id=this.project_id;
      ERP.getRequest({
        url:"admin/meter/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 99999
        }
      },ret=>{
        if(ret.code){
          that.meter_list=ret.data.list;
        }
      })
    },

  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SecpMeter/MeterExcel.vue